export type ResultadoDeCompartilhar =
  'compartilhado' | 'cancelado' | 'indisponivel';

export async function compartilharTexto(
  texto: string,
  compartilhar: ((dados: { text: string }) => Promise<void>) | undefined,
): Promise<ResultadoDeCompartilhar> {
  if (!compartilhar) return 'indisponivel';
  try {
    await compartilhar({ text: texto });
    return 'compartilhado';
  } catch (erro) {
    if (erro instanceof Error && erro.name === 'AbortError') return 'cancelado';
    throw erro;
  }
}
